import React                     from 'react';
import { Observe }               from 'rewire-core';
import {
  WithStyle,
  ActionMenu,
  IActionMenuItem,
}                                from 'rewire-ui';
import merge                     from 'deepmerge';
import { IUdf }                  from '../DataTypes';
import { PopoverOrigin }         from '@material-ui/core/Popover';
import { Theme }                 from '@material-ui/core/styles';
import { ButtonProps }           from '@material-ui/core/Button';
import AddIcon                   from '@material-ui/icons/AddCircleOutline';
import UdfsModel                 from '../schedule/UdfsModel';
import udfsSubscriptionService   from '../services/UdfsSubscriptionService';
import { withStyles }            from '../utility/styles';

const styles = (theme: Theme) => ({
  root: {
    display: 'flex',
    alignItems: 'stretch',
  },
  addMenuButton: {
    minHeight: '0px',
    fontWeight: 'bold',
    '&:hover, &:active': {
      background: 'transparent',
      color: theme.palette.primary.light,
    },
  },
  listItemText: {
    fontSize: 'inherit',
  },
  addIcon: {
    fontSize: 24,
  },
});

interface IUdfAddMenuProps {
  udfsModel: UdfsModel;
}

type UdfAddMenuProps = WithStyle<ReturnType<typeof styles>, IUdfAddMenuProps>;

class UdfAddMenu extends React.Component<UdfAddMenuProps> {
  constructor(props: UdfAddMenuProps) {
    super(props);
  }

  shouldComponentUpdate(_nextProps: UdfAddMenuProps) {
    return false;
  }

  handleAddNewUdfClick = () => {
    const newItem = {displayName: '<New Udf>'};
    this.props.udfsModel.addItem(newItem);
  };

  getHandleAddBuiltInUdfClick = (builtInUdf: IUdf) => () => {
    const newItem = merge({}, builtInUdf);
    this.props.udfsModel.addItem(newItem);
  };

  render() {
    return <Observe render={() => {
      const {classes, udfsModel}           = this.props;
      const buttonContent                  = <AddIcon fontSize='large' className={classes.addIcon} />;
      const buttonProps:     ButtonProps   = {disableRipple: true, size: 'large', disabled: !udfsModel.canAdd};
      const anchorOrigin:    PopoverOrigin = {vertical: 'bottom', horizontal: 'right'};
      const transformOrigin: PopoverOrigin = {vertical: 'top',    horizontal: 'right'};

      const items: IActionMenuItem[]       = [
        {name: 'newUdf', title: 'New Udf', subheader: 'Add New Udf', icon: AddIcon, divider: true, closeOnClick: true, onClick: this.handleAddNewUdfClick, disabled: () => !udfsModel.canAdd},
      ];
      udfsSubscriptionService.subscriptionModel.getBuiltInUdfsNotInUse(udfsModel.documentType).forEach((bu, idx) => {
        items.push({
          name: bu.name, title: bu.displayName, subheader: idx === 0 ? 'Add Built In Udfs' : undefined, divider: true, closeOnClick: true, onClick: this.getHandleAddBuiltInUdfClick(bu), disabled: () => !udfsModel.canAdd
        });
      });

      return (
        <div className={classes.root}>
          <ActionMenu
            menuId='udf-add-menu'
            tooltip='Add'
            items={items}
            buttonContent={buttonContent}
            buttonProps={buttonProps}
            classes={{menuButton: classes.addMenuButton, listItemText: classes.listItemText}}
            getContentAnchorEl={null}
            anchorOrigin={anchorOrigin}
            transformOrigin={transformOrigin}
          />
        </div>
      );
    }} />;
  }
}

export default withStyles<IUdfAddMenuProps>(styles, UdfAddMenu);
